import Form from 'react-bootstrap/Form';

type Props = {
  value: string;
  onChange: (value: string) => void;
  matchCount: number;
  total: number;
  placeholder?: string;
};

/** Search box shown above the item navigation lists on the LiveOps Items screens. */
const ItemSearchBox = ({ value, onChange, matchCount, total, placeholder = 'Search by ID or name' }: Props) => (
  <Form className="mb-2" onSubmit={(event: React.FormEvent<HTMLFormElement>) => event.preventDefault()}>
    <Form.Control
      type="search"
      placeholder={placeholder}
      value={value}
      onChange={(event: React.ChangeEvent<HTMLInputElement>) => onChange(event.target.value)}
      aria-label="Search items by ID or name"
    />
    {value.trim() !== '' && (
      <Form.Text className="text-muted text-center">
        {matchCount} of {total} match{matchCount === 1 ? '' : 'es'}
      </Form.Text>
    )}
  </Form>
);

export default ItemSearchBox;
